module.exports = __webpack_public_path__ + "static/ctaBackground-ec59fd09c117d338e8e52291d638bf83.svg";